import { render, staticRenderFns } from "./LinkageChart.vue?vue&type=template&id=10a0c064"
import script from "./LinkageChart.vue?vue&type=script&lang=js"
export * from "./LinkageChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports